import backofficeApi from "./backofficeApi"



/* Fraîcheur, champs additionnels : ces fonctions laissent remonter l'erreur
   axios. Renvoyer l'erreur comme une valeur faisait passer un refus serveur
   pour un succès chez l'appelant. Les types de localisation (/token) ont
   disparu avec token_configuration (Z2-18) : le référentiel des types de
   lieu fait foi, voir typeLieuService. */

/* Concours (décision D8) : le serveur refuse (409) toute modification ou
   suppression d'un concours commencé. L'erreur remonte à l'appelant, qui
   l'affiche au lieu de croire l'opération faite. */
export async function updateBonus(tokenId: any, formData: any) {
  const res = await backofficeApi.put(`/bonus/` + tokenId, formData);
  return res.data;
};


export async function updateBonusDelete(bonusId: any, formData: any) {
  const res = await backofficeApi.put(`/bonus/delete/` + bonusId, formData);
  return res.data;
};


export async function updateuser(userId: any) {
  try {
    const res = await backofficeApi.put(`/users/update/` + userId);
    return res.data;

  } catch (error) {
    console.log(error);
    return error;
  }
};


export async function updateusers(updateusers: any) {
  try {
    const res = await backofficeApi.put(`/users/update/` + updateusers);
    return res.data;

  } catch (error) {
    console.log(error);
    return error;
  }
};

/* Système de réputation (concours, badges, Tips offerts au palier) : ces
   wrappers laissent remonter l'erreur. Avant, ils renvoyaient l'objet erreur
   comme une réponse et l'écran annonçait un succès. */
export async function updateAchievements(achievementid: any, formData: any) {
  const res = await backofficeApi.put(`/achievement/delete/` + achievementid, formData);
  return res.data;
}


export async function updateAchievements1(achievementid: any, formData: any) {
  const res = await backofficeApi.put(`/achievement/` + achievementid, formData);
  return res.data;
}


export async function updategifts(giftid: any, formData: any) {
  const res = await backofficeApi.put(`gift/delete/` + giftid, formData);
  return res.data;
}


export async function deleteAddMore(addmoreId: any, formData: any) {
  const res = await backofficeApi.put(`Additional/delete/${addmoreId}`, formData);
  return res.data;
}


export async function updategift(giftid: any, formData: any) {
  const res = await backofficeApi.put(`gift/` + giftid, formData);
  return res.data;
}


export async function updateAddmore(addmoreId: any, formData: any) {
  const response = await backofficeApi.put(`/Additional/update/` + addmoreId, formData)
  return response.data
}



export async function getactivegifts() {
  const response = await backofficeApi.get('/gift/active')
  return response.data
}


export async function getBonus() {
  const response = await backofficeApi.get(`bonus`)
  return response.data
}


export async function getgifts() {
  const response = await backofficeApi.get(`gift`)
  return response.data
}


export async function getBonusId(bonusId: any) {
  const response = await backofficeApi.get(`bonus/` + bonusId)
  return response.data
}


export async function getgiftbyid(giftId: any) {
  const response = await backofficeApi.get(`gift/` + giftId)
  return response.data
}


export async function getAddmorebyid(addmoreId: any) {
  const response = await backofficeApi.get(`Additional/` + addmoreId)
  return response.data
}


export async function getActiveAddMore() {
  const response = await backofficeApi.get('Additional/active')
  return response.data
}


export async function getAchievements(achievementId: any) {
  const response = await backofficeApi.get(`achievement/` + achievementId)
  return response.data
}


export async function getActiveBonus() {
  const response = await backofficeApi.get(`bonus/active`)
  return response.data
}


export async function getAchievementsActive() {
  const response = await backofficeApi.get(`achievement/active`)
  return response.data
}




export async function addBonus(formData: any) {
  const response = await backofficeApi.post(`bonus`, formData)
  return response.data
}


export async function creategift(formData: any) {
  const response = await backofficeApi.post(`gift`, formData)
  return response.data
}


export async function createAddmore(formData: any) {
  const response = await backofficeApi.post(`Additional`, formData)
  return response.data
}


export async function createAchievement(formData: any) {
  const response = await backofficeApi.post(`achievement`, formData)
  return response.data
}

export async function getAllLocation() {
  try {
    const response = await backofficeApi.get('/locations/all')
    return response.data
  } catch (error) {
    return error
  }
}

export async function getAllUser() {
  try {
    const response = await backofficeApi.get('/users/all')
    return response.data
  } catch (error) {
    return error
  }
}

